import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'
import { useLayoutStore } from '@stores/layout/layout.store'

let isRegistered = false

/** Core layout store cannot import module stores, so the shell wires module → layout reactions. Idempotent. */
export function registerLayoutModuleSubscriptions(): void {
  if (isRegistered) return
  isRegistered = true

  useWorkspacesStore.subscribe(
    (state) => state.createProjectForWorkspaceId,
    (createProjectForWorkspaceId) => {
      if (createProjectForWorkspaceId) {
        useLayoutStore.getState().openCreateProjectDialog()
      }
    }
  )
}
